import {
  EDITA_TURNOSDISPONIBLES,
  FINALIZA_TURNOSDISPONIBLES,
  RESET_FILTROSDISPONIBLES,
  RESET_PORTAL_CONTEXT,
  SET_FECHA_TURNOS,
  SET_TURNOS_DATA,
} from "../ActionTypes";

import turnosDisponiblesInitialState from "../initialStates/turnosDisponiblesInitialState";

const turnosDisponibles = (state, { payload, type }) => {
  switch (type) {
    case EDITA_TURNOSDISPONIBLES:
      return {
        ...state,
        turnosDisponibles: {
          ...state.turnosDisponibles,
          turnosData: payload,
        },
      };

    case RESET_FILTROSDISPONIBLES:
      return {
        ...state,
        turnosDisponibles: {
          ...state.turnosDisponibles,
          turnosData: {
            ...state.turnosDisponibles.turnosData,
            filtrosData: {
              centros: [
                { id: 0, descripcion: "Todos los centros", checked: true },
              ],
              centrosLabo: [
                { id: 0, descripcion: "Todos los centros", checked: true },
              ],
              fecha: "",
              dias: [
                { id: 0, descripcion: "Todos", checked: true },
                {
                  id: 1,
                  descripcion: "Lunes",
                  checked: true,
                },
                {
                  id: 2,
                  descripcion: "Martes",
                  checked: true,
                },
                {
                  id: 3,
                  descripcion: "Miércoles",
                  checked: true,
                },
                {
                  id: 4,
                  descripcion: "Jueves",
                  checked: true,
                },
                {
                  id: 5,
                  descripcion: "Viernes",
                  checked: true,
                },
                {
                  id: 6,
                  descripcion: "Sábado",
                  checked: true,
                },
                {
                  id: 7,
                  descripcion: "Domingo",
                  checked: true,
                },
              ],
              diasKin: [
                { id: 0, descripcion: "Todos", checked: true },
                {
                  id: 1,
                  descripcion: "Lunes",
                  checked: false,
                },
                {
                  id: 2,
                  descripcion: "Martes",
                  checked: false,
                },
                {
                  id: 3,
                  descripcion: "Miércoles",
                  checked: false,
                },
                {
                  id: 4,
                  descripcion: "Jueves",
                  checked: false,
                },
                {
                  id: 5,
                  descripcion: "Viernes",
                  checked: false,
                },
                {
                  id: 6,
                  descripcion: "Sábado",
                  checked: false,
                },
                {
                  id: 7,
                  descripcion: "Domingo",
                  checked: false,
                },
              ],
              rangoHorario: [
                { id: 0, descripcion: "Todos", checked: true },
                {
                  id: 1,
                  descripcion: "Mañana",
                  horaMin: "07",
                  horaMax: "12",
                  checked: false,
                },
                {
                  id: 2,
                  descripcion: "Media tarde",
                  horaMin: "12",
                  horaMax: "16",
                  checked: false,
                },
                {
                  id: 3,
                  descripcion: "Tarde",
                  horaMin: "16",
                  horaMax: "19",
                  checked: false,
                },
                {
                  id: 4,
                  descripcion: "Noche",
                  horaMin: "19",
                  horaMax: "24",
                  checked: false,
                },
                {
                  id: 5,
                  descripcion: "Madrugada",
                  horaMin: "00",
                  horaMax: "07",
                  checked: false,
                },
              ],
              rangoKinesio: [
                { id: 0, descripcion: "Todos", checked: true },
                {
                  id: 1,
                  descripcion: "7:30 a 10hs",
                  rango: "730|1000",
                  checked: false,
                },
                {
                  id: 2,
                  descripcion: "10 a 12hs",
                  rango: "1000|1200",
                  checked: false,
                },
                {
                  id: 3,
                  descripcion: "12 a 14hs",
                  rango: "1200|1400",
                  checked: false,
                },
                {
                  id: 4,
                  descripcion: "14 a 16hs",
                  rango: "1400|1600",
                  checked: false,
                },
                {
                  id: 5,
                  descripcion: "16 a 18hs",
                  rango: "1600|1800",
                  checked: false,
                },
                {
                  id: 6,
                  descripcion: "18 a 20hs",
                  rango: "1800|2000",
                  checked: false,
                },
              ],
              especialistas: [{ id: 0, descripcion: "Todos", checked: true }],
            },
          },
        },
      };

    case FINALIZA_TURNOSDISPONIBLES:
      //revisar porque no tomar el initial state completo.
      return {
        ...state,
        turnosDisponibles: {
          turnosData: {
            turnos: null,
            grupoMedico: null,
            GruposMedico: null,
            particular: null,
            idEstudio: null,
            descEstudio: null,
            descEspecialidad: null,
            fechaBusqueda: null,
            dtoBusqueda: null,
            proceso: null,
            filtrosData: {
              centros: [
                { id: 0, descripcion: "Todos los centros", checked: true },
              ],
              centrosLabo: [
                { id: 0, descripcion: "Todos los centros", checked: true },
              ],
              fecha: "",
              dias: [
                { id: 0, descripcion: "Todos", checked: true },
                {
                  id: 1,
                  descripcion: "Lunes",
                  checked: true,
                },
                {
                  id: 2,
                  descripcion: "Martes",
                  checked: true,
                },
                {
                  id: 3,
                  descripcion: "Miércoles",
                  checked: true,
                },
                {
                  id: 4,
                  descripcion: "Jueves",
                  checked: true,
                },
                {
                  id: 5,
                  descripcion: "Viernes",
                  checked: true,
                },
                {
                  id: 6,
                  descripcion: "Sábado",
                  checked: true,
                },
                {
                  id: 7,
                  descripcion: "Domingo",
                  checked: true,
                },
              ],
              diasKin: [
                { id: 0, descripcion: "Todos", checked: true },
                {
                  id: 1,
                  descripcion: "Lunes",
                  checked: false,
                },
                {
                  id: 2,
                  descripcion: "Martes",
                  checked: false,
                },
                {
                  id: 3,
                  descripcion: "Miércoles",
                  checked: false,
                },
                {
                  id: 4,
                  descripcion: "Jueves",
                  checked: false,
                },
                {
                  id: 5,
                  descripcion: "Viernes",
                  checked: false,
                },
                {
                  id: 6,
                  descripcion: "Sábado",
                  checked: false,
                },
                {
                  id: 7,
                  descripcion: "Domingo",
                  checked: false,
                },
              ],
              rangoHorario: [
                { id: 0, descripcion: "Todos", checked: true },
                {
                  id: 1,
                  descripcion: "Mañana",
                  horaMin: "07",
                  horaMax: "12",
                  rangoKinesio: "730|1000",
                  checked: false,
                },
                {
                  id: 2,
                  descripcion: "Media tarde",
                  horaMin: "12",
                  horaMax: "16",
                  rangoKinesio: "1000|1200",
                  checked: false,
                },
                {
                  id: 3,
                  descripcion: "Tarde",
                  horaMin: "16",
                  horaMax: "19",
                  rangoKinesio: "1200|1400",
                  checked: false,
                },
                {
                  id: 4,
                  descripcion: "Noche",
                  horaMin: "19",
                  horaMax: "24",
                  rangoKinesio: "1400|1600",
                  checked: false,
                },
                {
                  id: 5,
                  descripcion: "Madrugada",
                  horaMin: "00",
                  horaMax: "07",
                  checked: false,
                },
              ],
              rangoKinesio: [
                { id: 0, descripcion: "Todos", checked: true },
                {
                  id: 1,
                  descripcion: "7:30 a 10hs",
                  rango: "730|1000",
                  checked: false,
                },
                {
                  id: 2,
                  descripcion: "10 a 12hs",
                  rango: "1000|1200",
                  checked: false,
                },
                {
                  id: 3,
                  descripcion: "12 a 14hs",
                  rango: "1200|1400",
                  checked: false,
                },
                {
                  id: 4,
                  descripcion: "14 a 16hs",
                  rango: "1400|1600",
                  checked: false,
                },
                {
                  id: 5,
                  descripcion: "16 a 18hs",
                  rango: "1600|1800",
                  checked: false,
                },
                {
                  id: 6,
                  descripcion: "18 a 20hs",
                  rango: "1800|2000",
                  checked: false,
                },
              ],
              especialistas: [{ id: 0, descripcion: "Todos", checked: true }],
            },
          },
        },
      };
    case SET_FECHA_TURNOS:
      return {
        ...state,
        turnosDisponibles: {
          ...state.turnosDisponibles,
          turnosData: {
            ...state.turnosDisponibles.turnosData,
            fechaSeleccionada: payload,
          },
        },
      };
    case RESET_PORTAL_CONTEXT:
      return turnosDisponiblesInitialState;

    default:
      return state;
  }
};

export default turnosDisponibles;
